/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

const initialState = {
    messages: {}
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_MESSAGE': 
            return {
                ...state, 
                messages: {
                    ...state.messages,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/shared/containers/IntlProvider/state/reducers.js